// Paths from assets/brand/vein_full.svg, viewBox tightened to the mark's own bounds.
export default function VeinWordmark({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="16 31 268 98"
      className={`text-vein-red-500 ${className}`}
      fill="currentColor"
      role="img"
      aria-label="Vein"
    >
      <path d="M98.6,36c.2,2.2-.6,7.1-1.2,10.4-1.6,9.1-7,25.2-19.8,35.7-14.7,12-34,14.3-48.1,27.9-1.1-4.2.7-18.3,3.6-25.8,3.6-9.5,9.9-18,17.1-25.1,6.6-6.4,17.7-13.9,20.2-23.2h-18.6c1.5,3.9-12.6,19-15.3,22.7-6.9-6.9-9.1-15-2.2-22.7s-15.1,0-15.1,0c0,1.6-2.3,13.8,9.2,32.5-15.8,31.4-10.4,58.9-10.1,59.8,0,0,14.9,0,14.9,0,17-18,31.9-20.4,36.7-22.4,20.4-8.6,35.4-26.2,40.9-47.6,1.9-7.3,3.2-14.8,3.2-22.3h-15.4Z" />
      <path d="M174.5,106.8l13.8-70.8h13.6l-13.8,70.8h-13.6Z" />
      <path d="M252,106.8l-25.6-55h-.2l-10.7,55h-13.6l13.8-70.8h17.7l25.2,53.3h.2l10.4-53.3h13.6l-13.8,70.8h-16.9Z" />
      <path d="M173.9,46.8l2.1-10.8h-49.2c-.4,18.7-10.6,60.1-38.3,70.8h39.5s37.4,0,37.4,0l2.1-11h-44.1c4.2-5.9,7.6-12.7,10.4-20.3h32.9l2.1-10.4h-31.8c1.7-6.8,2.7-13.1,3.2-18.3h33.8Z" />
    </svg>
  );
}
